import { render, staticRenderFns } from "./countdownDzp.vue?vue&type=template&id=92b185a8&scoped=true&"
import script from "./countdownDzp.vue?vue&type=script&lang=js&"
export * from "./countdownDzp.vue?vue&type=script&lang=js&"
import style0 from "./countdownDzp.vue?vue&type=style&index=0&id=92b185a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b185a8",
  null
  
)

export default component.exports